import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const invoiceRoutes: RouteObject[] = [
  {
    path: '/invoice',
    element: lazyElement(() => import('./Search')),
    handle: {
      documentTitle: 'Invoicing',
      crumb: () => ({ label: 'Invoicing', to: '/invoice' }),
    },
  },
];

export default invoiceRoutes;
